import { render, staticRenderFns } from "./orderitem.vue?vue&type=template&id=029854c0&scoped=true&"
import script from "./orderitem.vue?vue&type=script&lang=js&"
export * from "./orderitem.vue?vue&type=script&lang=js&"
import style0 from "./orderitem.vue?vue&type=style&index=0&id=029854c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029854c0",
  null
  
)

export default component.exports